export default __webpack_public_path__ + "static/media/university-notre-dame.9c196e59.png";